import { _get, _post } from "./Axios";

export default class LaporanKurvaNormal {
  static getKurvaNormalPegawai(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      if (parameters[element])
        params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("report/kurva-normal/pegawai?" + params);
  }

  static koreksiKurvaNormalPegawai(data) {
    return _post("report/kurva-normal/keselarasan", data);
  }

  static getKurvaNormalCabang(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      if (parameters[element])
        params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("report/kurva-normal/cabang?" + params);
  }
}
